var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('div',{key:_vm.valueFormat,staticClass:"wrapper-right text-h5"},[_vm._v(" "+_vm._s(_vm.valueFormat)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }